import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { List, ListSubheader } from '@material-ui/core';
import NavItem from './NavList/NavItem';

function getNavItems(items, onNavItem) {
  return items.map((navItem) => (
    <NavItem key={navItem.url} navItem={navItem} depth={1} onNavItem={onNavItem} />
  ));
}

export function NavListImpl({ items, onNavItem }) {
  return (
    <List>
      <ListSubheader />
      {getNavItems(items, onNavItem)}
    </List>
  );
}

const navListPropTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  onNavItem: PropTypes.func.isRequired,
};

export { navListPropTypes };

NavListImpl.propTypes = navListPropTypes;

export function mapStateToProps(state) {
  const items = state.nav.showActions
    ? state.nav.items.filter((i) => i.type === 'action')
    : state.nav.items.filter((i) => i.type !== 'action');
  return {
    items,
  };
}

export default connect(mapStateToProps)(NavListImpl);
